import { createSelector } from '@reduxjs/toolkit';
import { getEmployees } from './get-employees';
import { _sortByName } from '../utilities/_sortByName';

export const getEmployeesAsUsers = createSelector(getEmployees, function (employees) {
  return employees
    .filter(function (e) {
      return !e.deleted;
    })
    .filter(function (e) {
      return e.status !== 'TERMINATED';
    })
    .map(function (e) {
      return {
        name: e.firstName + ' ' + e.lastName,
        accessLevel: e.accessLevel,
        uuid: e.uuid,
        email: e.email,
      };
    })
    .sort(_sortByName);
});
